import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Post } from "./../../models/post";
import * as lodash from "lodash";
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { DatePipe } from "@angular/common";
import { OAuthService } from "app/services/o-auth";
import { ThrowStmt } from "@angular/compiler";
import { ApiService } from "app/services/api";

@Component({
  templateUrl: "./post.everyone.component.html",
})
export class PostEveryoneComponent implements OnInit {
  public list: any[];
  public filterargs: Post;
  public date: any;
  private attachmentExt: string;
  public text: string;
  public shared: Post;
  public mentioned: Array<any>;
  public commentList: Array<any>;
  public likeList: Array<{ author: string; authorImage: string; key: string }>;
  public shareLikes: Array<{
    author: string;
    authorImage: string;
    key: string;
  }>;
  public shareComments: Array<any>;
  public postData: any;
  private shortPosts: Array<{ $value: string; $key: string }>;
  public query: string;
  public imageLoader = true;
  public likeCount: number;
  public commentCount: number;
  public mentionCount: number;
  public club: any;

  constructor(
    private fireAuth: AngularFireAuth,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase,
    private datePipe: DatePipe,
    private changeDetectorRef: ChangeDetectorRef,
    private apiService: ApiService
  ) {
    this.filterargs = new Post();
    this.club = this.oAuthService.getClub();
  }
  public dateChange(event) {
    this.filterargs.date = this.datePipe.transform(event, "yyyy-MM-dd");
  }
  listMap = new Map();
  postAuthors = new Map();
  async ngOnInit() {
    this.fireDatabase.object(`/user-permissions/${this.club.uid}/${this.club.cid}/magazine_portal/all`).subscribe(result => {
      if (result.$exists()) {
        this.fireDatabase.object(`/user-portal-posts/${this.club.uid}`).subscribe(profilePosts => {
          this.list = [];
          lodash.forEach(profilePosts, (postIds, authorId) => {
            lodash.forEach(postIds, (value, postId) => {
              this.fireDatabase.object(`/users-posts/${this.club.cid}/${postId}`).subscribe(post => {
                this.list.push(post);
                let value = this.listMap.get(post.userId ? post.userId : post.author)
                if (value) {
                  value.push(post);
                  this.listMap.set(post.userId ? post.userId : post.author, value)
                }
                else {
                  let arr = []
                  arr.push(post);
                  this.listMap.set(post.userId ? post.userId : post.author, arr);
                  this.fireDatabase.object(`/users/${post.userId ? post.userId : post.author}`).subscribe(user => {
                    this.postAuthors.set(post.userId ? post.userId : post.author, user);
                  });
                }
              });
            });
          });
          this.imageLoader = false;
        });
      }
      else {
        this.loadData();
      }
    });
  }

  loadData()
  {
    let cid = this.club.cid ? this.club.cid : this.club.uid;
    this.fireDatabase.list(`/users-posts/${cid}`).subscribe(
      async (result: Array<any>) => {
        this.list = [];
        this.listMap.clear();
        let count = 0;
        lodash.forEach(result, async (item) => {
          if (item.text) {
            var date = new Date(item.date * 1000);
            var o =
              date.getFullYear() +
              "-" +
              ("0" + (date.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + date.getDate()).slice(-2);
            if(!isNaN(item.date))
            {
              item.date = o;
            }
            if (this.club.cid == item.author && this.club.role == 1) {
              let value = this.listMap.get(item.userId ? item.userId : item.author)
              if (value)
              {
                value.push(item);
                this.listMap.set(item.userId ? item.userId: item.author, value)
              }
              else {
                let user = await this.apiService.object(`/users/${item.userId ? item.userId : item.author}`); //userId exists
                  if (user.$exists()) {
                    
                    let value = this.listMap.get(item.userId ? item.userId : item.author);
                    if (value)
                    {
                      value.push(item);
                      this.listMap.set(item.userId ? item.userId : item.author, value);
                    }
                    else {
                      let arr = []
                      arr.push(item);
                      this.listMap.set(item.userId ? item.userId : item.author, arr);
                    }
                    
                    this.postAuthors.set(item.userId ? item.userId : item.author, user);
                    
                  }
                  else { //userId doesnt exists, uid exists
                   
                    let user1 = await this.apiService.object(`/users/${item.uid ? item.uid : item.author}`);
                    if (user1.exists()) 
                    {
                      
                      let value = this.listMap.get(item.uid ? item.uid : item.author);
                      if (value)
                      {
                        value.push(item);
                        this.listMap.set(item.uid ? item.uid : item.author, value);
                      }
                      else {
                        let arr = []
                        arr.push(item);
                        this.listMap.set(item.uid ? item.uid : item.author, arr);
                      }
                      this.postAuthors.set(item.uid ? item.uid : item.author, user1);
                    }
                    
                  }
              }
              this.list.push(item);
              count++;
              if (count === 1) {
                this.postDetail(item);
              }
            }
            else if (this.club.uid == item.userId && this.club.role != 1)
            {
                let value = this.listMap.get(item.userId ? item.userId: item.author)
                if (value)
                {
                  value.push(item);
                  this.listMap.set(item.userId ? item.userId: item.author, value)
                }
                else {
                  
                  let user = await this.apiService.object(`/users/${item.userId ? item.userId : item.author}`); //userId exists
                  if (user.$exists()) {
                    
                    let value = this.listMap.get(item.userId ? item.userId : item.author);
                    if (value)
                    {
                      value.push(item);
                      this.listMap.set(item.userId ? item.userId : item.author, value);
                    }
                    else {
                      let arr = []
                      arr.push(item);
                      this.listMap.set(item.userId ? item.userId : item.author, arr);
                    }
                    
                    this.postAuthors.set(item.userId ? item.userId : item.author, user);
                    
                  }
                  else { //userId doesnt exists, uid exists
                   
                    let user1 = await this.apiService.object(`/users/${item.uid ? item.uid : item.author}`);
                    if (user1.exists()) 
                    {
                      
                      let value = this.listMap.get(item.uid ? item.uid : item.author);
                      if (value)
                      {
                        value.push(item);
                        this.listMap.set(item.uid ? item.uid : item.author, value);
                      }
                      else {
                        let arr = []
                        arr.push(item);
                        this.listMap.set(item.uid ? item.uid : item.author, arr);
                      }
                      this.postAuthors.set(item.uid ? item.uid : item.author, user1);
                    }
                    
                  }
                }
                this.list.push(item);
                count++;
                if (count === 1) {
                  this.postDetail(item);
                }
            }
              
          }
        });

        console.log(this.postAuthors, this.listMap);
        
        this.imageLoader = false;
      },
      (error) => {
        console.error(error);
        this.imageLoader = false;
      }
    );
  }

  getKeys(map){
    return Array.from(map.keys());
  }

  getValue(key)
  {
    return this.postAuthors.get(key);
  }

  getListFromListMap(key)
  {
    return this.listMap.get(key);
  }

  getTabName(key)
  {
    let user = this.getValue(key);
    if (user.username)
      return user.username
    else if (user.fullName)
      return user.fullName
    else if (user.firstName)
      return user.firstName
    else if (user.lastName)
      return user.lastName
    else return "unknown user"
  }

  postDetail(post: Post) {
    $("html, body").animate({ scrollTop: "1px" });
    this.commentList = [];
    this.likeList = [];
    this.shareLikes = [];
    this.shareComments = [];
    this.postData = post;
    if (post.photo) {
      this.attachmentExt = post.photo.url;
    }
    this.text = this.postData.text;
    this.fireDatabase.object(`/users/${post.author}`).subscribe((user: any) => {
      this.postData.authorName = user.username;
      this.postData.authorImage = user.avatar_thumb;
    });
    if (this.postData.mentioned) {
      this.mentioned = [];
      this.mentionCount = 0;
      lodash.forEach(this.postData.mentioned, (mention, key) => {
        this.mentionCount++;
        this.mentioned.push({
          user_name: mention.username,
          user_id: key,
          type: mention.type,
        });
      });
    }
    if (this.postData.shared) {
      this.fireDatabase
        .object(
          `/users-posts/${this.postData.shared.uid}/${this.postData.shared.pid}`
        )
        .subscribe((shared) => {
          this.shared = shared;
          if (shared.$value) {
            this.postData.isShared = true;
            this.fireDatabase
              .object(`/users/${shared.author}`)
              .subscribe((user: any) => {
                this.postData.Sharedauthor = user.username;
                this.postData.SharedauthorImage = user.avatar_thumb;
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/likes`)
              .subscribe((likes) => {
                if (likes) {
                  lodash.forEach(likes, (like) => {
                    this.fireDatabase
                      .object(`/users/${like}`)
                      .subscribe((user: any) => {
                        like = user.username;
                        this.shareLikes.push({
                          author: user.username,
                          authorImage: user.avatar_thumb,
                          key: user.$key,
                        });
                      });
                  });
                }
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/comments`)
              .subscribe((comments) => {
                if (comments) {
                  lodash.forEach(comments, (comment) => {
                    if (comment) {
                      this.fireDatabase
                        .object(`/users/${comment.author}`)
                        .subscribe((user: any) => {
                          comment.author = user.username;
                          comment.authorImage = user.avatar_thumb;
                          comment.key = user.$key;
                          this.shareComments.push(comment);
                        });
                    }
                  });
                }
              });
          }
        });
    } else {
      this.postData.isShared = false;
    }
    this.fireDatabase.object(`/posts/${post.$key}/likes`).subscribe((likes) => {
      this.likeCount = 0;
      if (likes) {
        lodash.forEach(likes, (item, like) => {
          this.likeCount++;
          if (item) {
            this.fireDatabase
              .object(`/users/${like}`)
              .subscribe((user: any) => {
                like = user.username;
                this.likeList.push({
                  author: user.username,
                  authorImage: user.avatar_thumb,
                  key: user.$key,
                });
              });
          }
        });
      }
    });
    this.fireDatabase
      .object(`/posts/${post.$key}/comments`)
      .subscribe((comments) => {
        this.commentCount = 0;
        if (comments) {
          lodash.forEach(comments, (comment) => {
            this.commentCount++;
            if (comment) {
              this.fireDatabase
                .object(`/users/${comment.author}`)
                .subscribe((user: any) => {
                  comment.author = user.username;
                  comment.authorImage = user.avatar_thumb;
                  comment.key = user.$key;
                  this.commentList.push(comment);
                  // this.postData.date = moment().unix();
                  lodash.forEach(this.commentList, (item) => {
                    item.date = new Date(item.date * 1000);
                    var dd = item.date.getDate();
                    var mm = item.date.getMonth() + 1;
                    var yyyy = item.date.getFullYear();
                    item.date = dd + "/" + mm + "/" + yyyy;
                  });
                });
            }
          });
        }
      });
  }
}
